import { ethers } from "ethers";
import Base721 from "./Base721";
import config from "../config";
import hivesabi from "../abis/hives.json";

class HivesContract extends Base721 {
    constructor(signer: ethers.Signer | ethers.providers.Provider) {
        super(config.hivesAddress, hivesabi, signer);
    }

    async exists(bearId: number): Promise<boolean> {
        return await this.contract.exists(bearId);
    }

    async getUsageOfMintingBee(hiveId: number): Promise<number> {
        const res = await this.contract.getUsageOfMintingBee(hiveId);
        return typeof res === 'number' ? res : (res ? Number(res) : 0);
    }

    async eligibleToMint(hiveId: number): Promise<boolean> {
        const res = await this.contract.eligibleToMint(hiveId);
        return Boolean(res);
    }

}

export default HivesContract;
